/* tslint:disable */

declare var Object: any;
export interface UIPublicInterface {
  "id"?: number;
}

export class UIPublic implements UIPublicInterface {
  "id": number;
  constructor(data?: UIPublicInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `UIPublic`.
   */
  public static getModelName() {
    return "UIPublic";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of UIPublic for dynamic purposes.
  **/
  public static factory(data: UIPublicInterface): UIPublic{
    return new UIPublic(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'UIPublic',
      plural: 'UIPublic',
      path: 'UIPublic',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
